import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderLevelsStore implements SaveStateHolder {
  @observable
  readonly levelIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly ageCategoryId: number, levelIds: number[]) {
    makeObservable(this);
    this.levelIds = levelIds.slice();
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.levelIds, index1, index2);
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    const reordered = this.levelIds.slice();
    this.save = contentLoaders.x2ageCategory.orderChildren(this.ageCategoryId, reordered);
  }
}
